import axios from 'axios';
import Pagination from '@/domain/pagination.entity';
import Response from '@/domain/response.entity';
import RuleGroup from '@/domain/scripts/entity/rule-group.entity';
import RuleGroupResponse from '@/domain/scripts/entity/rule-group-response';
import RuleGroupFilter from '@/domain/scripts/entity/rule-group-filter.entity';
import RuleGroupRequest from '../entity/rule-group-request';

export default class RuleGroupService {
  public static getAll(businessUnitId: string): Promise<RuleGroupResponse[]> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/rule-group`)
      .then((response: any) => RuleGroupResponse.ofList(response.data))
  }

  public static getRuleGroupByContractItemId(businessUnitId: string, contractItemId: string)
  : Promise<RuleGroupResponse> {
    return axios
      .get(`/api/v1/business-units/${businessUnitId}/rule-group/contractitem/${contractItemId}`)
      .then((response: any) => RuleGroupResponse.of(response.data))
  }

  public static filterRulesGroup(
    pagination: Pagination, businessUnitId: string, filter: RuleGroupFilter,
  ): Promise<Response> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/rule-group/filter`, {
      params: {
        page: pagination.page - 1,
        size: pagination.itemsPerPage,
        name: filter.name,
        status: filter.status || null,
      },
    }).then((response: any) => Response.of(response.data))
  }

  public static getRuleGroup(businessUnitId: string, ruleGroupId: string)
  : Promise<RuleGroupResponse> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/rule-group/${ruleGroupId}`)
      .then((response: any) => RuleGroupResponse.of(response.data))
  }

  public static approveRuleGroup(businessUnitId: string, ruleGroupId: string): Promise<void> {
    return axios.put(`/api/v1/business-units/${businessUnitId}/rule-group/${ruleGroupId}/approval`)
  }

  public static deleteRuleGroup(businessUnitId: string, ruleGroupId: string): Promise<void> {
    return axios.delete(`/api/v1/business-units/${businessUnitId}/rule-group/${ruleGroupId}`)
  }

  public static saveRuleGroup(businessUnitId: string, ruleGroup: RuleGroup)
    : Promise<RuleGroupResponse> {
    const ruleGroupRequest = RuleGroupRequest.of(ruleGroup);
    return axios.post(`/api/v1/business-units/${businessUnitId}/rule-group`, ruleGroupRequest)
      .then((response: any) => RuleGroupResponse.of(response.data))
  }

  public static updateRuleGroup(
    businessUnitId: string, ruleGroup: RuleGroup,
  ): Promise<RuleGroupResponse> {
    const ruleGroupRequest = RuleGroupRequest.of(ruleGroup);
    return axios.put(`/api/v1/business-units/${businessUnitId}/rule-group/${ruleGroup.id}`,
      ruleGroupRequest)
      .then((response: any) => RuleGroupResponse.of(response.data))
  }
}
